import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ButtonComponent } from '@app/shared/button/button.component';
import { STREAMING_SERVICE_URI } from '@modules/video-player/video-player.module';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import videojs from 'video.js/dist/video.min';
import { VideoReviewType } from '@modules/real-property-data/services';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent],
})
export class VideoModalComponent implements OnInit {
  videoInfo: VideoReviewType;
  videoId: string;
  videoThumbnail: string;
  player: videojs.Player;
  isPlayerReady = false;
  @ViewChild('videoPlayer', { static: true }) videoPlayer: ElementRef;
  constructor(
    @Inject(STREAMING_SERVICE_URI) private _streamingServiceURI: string,
    private _dialogConfig: DynamicDialogConfig,
    private _dialogRef: DynamicDialogRef,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.videoInfo = this._dialogConfig.data.videoInfo;
    this.videoThumbnail = this._dialogConfig.data.videoThumbnail;
    this.initPlayer();
    this.createIdForVideo();
  }

  async initPlayer() {
    this.player = videojs(this.videoPlayer.nativeElement, {
      autoplay: false,
      controls: false,
      bigPlayButton: false,
      controlBar: {
        playToggle: true,
        currentTimeDisplay: false,
        timeDivider: false,
        durationDisplay: false,
        remainingTimeDisplay: false,
        liveDisplay: false,
        progressControl: true,
        volumePanel: false,
        fullscreenToggle: true,
      },
    });

    this.videoInfo.src = await (this._streamingServiceURI + this.videoInfo.src);
    this.player.textTracks();
    this.player.src({
      src: this.videoInfo.src,
      type: 'application/x-mpegURL',
    });

    this.player.on('ready', () => {
      this.isPlayerReady = true;
    });

    this.hideUnnecessaryElements();
    this.player.on('click', (e) => {
      this.handleVideo(e);
    });
  }

  handleVideo(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.player.paused() ? this.player.play() : this.player.pause();
    this._cdr.detectChanges();
  }

  hideUnnecessaryElements() {
    this.player.loadingSpinner.hide();
  }

  public changeSound(event: MouseEvent): void {
    event.stopPropagation();
    this.player.muted() ? this.player.muted(false) : this.player.muted(true);
  }

  createIdForVideo() {
    this.videoId = `video-preview-${this.videoInfo.id}`;
  }

  closeDialog() {
    this._dialogRef.close();
  }
}
